import React from 'react';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = 'h-24 w-24'
}: LogoProps) {
  return <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Trip Ink Tattoo Co. — Las Vegas, Nevada" data-id="element-156" data-mp="yc7mg75b9v7o">
      <defs data-id="element-157" data-mp="t9yqr3120f1v">
        <path id="logo-top" d="M 34,100 A 66,66 0 0 1 166,100" data-id="element-158" data-mp="tdwc7vb3tiox" />
        <path id="logo-bottom" d="M 22,100 A 78,78 0 0 0 178,100" data-id="element-159" data-mp="obx7agzpudpv" />
      </defs>
      <circle cx="100" cy="100" r="98" fill="#ffffff" data-id="element-160" data-mp="kbdbbgqvpg5b" />
      <circle cx="100" cy="100" r="92" fill="none" stroke="#0e0e0e" strokeWidth="3" data-id="element-161" data-mp="kcy6n8l0p348" />
      <text fill="#0e0e0e" fontFamily="'Roboto Slab', Georgia, serif" fontWeight="800" fontSize="30" letterSpacing="3" data-id="element-162" data-mp="fj3qgf4mf69w">
        <textPath href="#logo-top" startOffset="50%" textAnchor="middle" data-id="element-163" data-mp="aizb4sfg8hl9">
          TRIP INK
        </textPath>
      </text>
      <text fill="#0e0e0e" fontFamily="'Roboto Slab', Georgia, serif" fontWeight="800" fontSize="24" letterSpacing="3" data-id="element-164" data-mp="nnprr9jcc4j">
        <textPath href="#logo-bottom" startOffset="50%" textAnchor="middle" data-id="element-165" data-mp="3srzrkclr4gv0">
          TATTOO CO.
        </textPath>
      </text>
      <g stroke="#0e0e0e" strokeLinecap="round" data-id="element-166" data-mp="1xrjv585cu85j">
        <line x1="72" y1="64" x2="128" y2="136" strokeWidth="13" data-id="element-167" data-mp="22k39i7bv97be" />
        <line x1="128" y1="64" x2="72" y2="136" strokeWidth="13" data-id="element-168" data-mp="22lecw61egd1z" />
      </g>
      <g fontFamily="'Roboto Slab', Georgia, serif" fontWeight="800" fontSize="15" textAnchor="middle" data-id="element-169" data-mp="1nwi6edezr83h">
        <circle cx="52" cy="100" r="14" fill="#ffffff" stroke="#0e0e0e" strokeWidth="2" data-id="element-170" data-mp="1su1ltgnfdqx0" />
        <text x="52" y="105" fill="#0e0e0e" data-id="element-171" data-mp="2gjvxvvzx7bg7">LV</text>
        <circle cx="148" cy="100" r="14" fill="#ffffff" stroke="#0e0e0e" strokeWidth="2" data-id="element-172" data-mp="2liz1dc0959m2" />
        <text x="148" y="105" fill="#0e0e0e" data-id="element-173" data-mp="27ixyjr0ffs3y">NV</text>
      </g>
    </svg>;
}